<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-04-26 13:47:54
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-26 13:29:40
-->
<template>
  <div :class="['model', type, theme]" :style="model">
    <div :class="['modelTitle', type]" :style="{ backgroundColor: bColor, color: textColor }">{{ title }}</div>
    <div class="modelBg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 335 149" :style="{ color: bColor }">
        <path d="M6.83673 0H0V6.83486H6.83673V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M17.7755 0H10.9388V6.83486H17.7755V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M28.7143 0H21.8775V6.83486H28.7143V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M39.6531 0H32.8163V6.83486H39.6531V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M50.5918 0H43.7551V6.83486H50.5918V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M61.5306 0H54.6939V6.83486H61.5306V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M72.4694 0H65.6327V6.83486H72.4694V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M83.4082 0H76.5714V6.83486H83.4082V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M94.3469 0H87.5102V6.83486H94.3469V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M105.286 0H98.449V6.83486H105.286V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M116.224 0H109.388V6.83486H116.224V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M120.327 0H127.163V6.83486H120.327V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M127.163 21.8716H120.327V28.7064H127.163V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M127.163 32.8073H120.327V39.6422H127.163V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M105.286 10.9358H98.449V17.7706H105.286V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M105.286 21.8716H98.449V28.7064H105.286V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M105.286 54.6789H98.449V61.5138H105.286V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M94.3469 21.8716H87.5102V28.7064H94.3469V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M94.3469 32.8073H87.5102V39.6422H94.3469V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M94.3469 54.6789H87.5102V61.5138H94.3469V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M83.4082 10.9358H76.5714V17.7706H83.4082V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M83.4082 21.8716H76.5714V28.7064H83.4082V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M83.4082 32.8073H76.5714V39.6422H83.4082V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M83.4082 54.6789H76.5714V61.5138H83.4082V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M72.4694 10.9358H65.6327V17.7706H72.4694V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M72.4694 21.8716H65.6327V28.7064H72.4694V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M72.4694 32.8073H65.6327V39.6422H72.4694V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M72.4694 43.7431H65.6327V50.578H72.4694V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M61.5306 10.9358H54.6939V17.7706H61.5306V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M61.5306 32.8073H54.6939V39.6422H61.5306V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M61.5306 43.7431H54.6939V50.578H61.5306V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M61.5306 65.6147H54.6939V72.4495H61.5306V65.6147Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M61.5306 76.5505H54.6939V83.3853H61.5306V76.5505Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M50.5918 21.8716H43.7551V28.7064H50.5918V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M50.5918 32.8073H43.7551V39.6422H50.5918V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M39.6531 10.9358H32.8163V17.7706H39.6531V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M39.6531 21.8716H32.8163V28.7064H39.6531V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M39.6531 43.7431H32.8163V50.578H39.6531V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M39.6531 65.6147H32.8163V72.4495H39.6531V65.6147Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M39.6531 76.5505H32.8163V83.3853H39.6531V76.5505Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M39.6531 98.422H32.8163V105.257H39.6531V98.422Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M28.7143 21.8716H21.8775V28.7064H28.7143V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M28.7143 32.8073H21.8775V39.6422H28.7143V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M28.7143 65.6147H21.8775V72.4495H28.7143V65.6147Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M28.7143 87.4862H21.8775V94.3211H28.7143V87.4862Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M28.7143 98.422H21.8775V105.257H28.7143V98.422Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M28.7143 109.358H21.8775V116.193H28.7143V109.358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M17.7755 10.9358H10.9388V17.7706H17.7755V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M17.7755 21.8716H10.9388V28.7064H17.7755V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M17.7755 32.8073H10.9388V39.6422H17.7755V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M17.7755 43.7431H10.9388V50.578H17.7755V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M17.7755 54.6789H10.9388V61.5138H17.7755V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M17.7755 87.4862H10.9388V94.3211H17.7755V87.4862Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M6.83673 10.9358H0V17.7706H6.83673V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M6.83673 21.8716H0V28.7064H6.83673V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M6.83673 32.8073H0V39.6422H6.83673V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M6.83673 43.7431H0V50.578H6.83673V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M6.83673 54.6789H0V61.5138H6.83673V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M6.83673 98.422H0V105.257H6.83673V98.422Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M131.265 0H138.102V6.83486H131.265V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M142.204 0H149.041V6.83486H142.204V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M153.143 0H159.98V6.83486H153.143V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M164.082 0H170.918V6.83486H164.082V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M164.082 10.9358H170.918V17.7706H164.082V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M175.02 0H181.857V6.83486H175.02V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M175.02 21.8716H181.857V28.7064H175.02V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M175.02 32.8073H181.857V39.6422H175.02V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M185.959 0H192.796V6.83486H185.959V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M196.898 0H203.735V6.83486H196.898V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M196.898 10.9358H203.735V17.7706H196.898V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M196.898 21.8716H203.735V28.7064H196.898V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M196.898 54.6789H203.735V61.5138H196.898V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M207.837 0H214.673V6.83486H207.837V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M207.837 21.8716H214.673V28.7064H207.837V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M207.837 32.8073H214.673V39.6422H207.837V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M207.837 54.6789H214.673V61.5138H207.837V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M218.775 0H225.612V6.83486H218.775V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M218.775 10.9358H225.612V17.7706H218.775V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M218.775 21.8716H225.612V28.7064H218.775V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M218.775 32.8073H225.612V39.6422H218.775V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M218.775 54.6789H225.612V61.5138H218.775V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M229.714 0H236.551V6.83486H229.714V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M229.714 10.9358H236.551V17.7706H229.714V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M229.714 21.8716H236.551V28.7064H229.714V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M229.714 32.8073H236.551V39.6422H229.714V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M229.714 43.7431H236.551V50.578H229.714V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M240.653 0H247.49V6.83486H240.653V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M240.653 10.9358H247.49V17.7706H240.653V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M240.653 32.8073H247.49V39.6422H240.653V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M240.653 43.7431H247.49V50.578H240.653V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M240.653 65.6147H247.49V72.4495H240.653V65.6147Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M240.653 76.5505H247.49V83.3853H240.653V76.5505Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M251.592 0H258.429V6.83486H251.592V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M251.592 21.8716H258.429V28.7064H251.592V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M251.592 32.8073H258.429V39.6422H251.592V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M262.531 0H269.367V6.83486H262.531V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M262.531 10.9358H269.367V17.7706H262.531V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M262.531 21.8716H269.367V28.7064H262.531V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M262.531 43.7431H269.367V50.578H262.531V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M262.531 65.6147H269.367V72.4495H262.531V65.6147Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M262.531 76.5505H269.367V83.3853H262.531V76.5505Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M262.531 98.422H269.367V105.257H262.531V98.422Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M273.469 0H280.306V6.83486H273.469V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M273.469 21.8716H280.306V28.7064H273.469V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M273.469 32.8073H280.306V39.6422H273.469V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M273.469 65.6147H280.306V72.4495H273.469V65.6147Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M273.469 87.4862H280.306V94.3211H273.469V87.4862Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M273.469 98.422H280.306V105.257H273.469V98.422Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M273.469 109.358H280.306V116.193H273.469V109.358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M284.408 0H291.245V6.83486H284.408V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M284.408 10.9358H291.245V17.7706H284.408V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M284.408 21.8716H291.245V28.7064H284.408V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M284.408 32.8073H291.245V39.6422H284.408V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M284.408 43.7431H291.245V50.578H284.408V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M284.408 54.6789H291.245V61.5138H284.408V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M284.408 87.4862H291.245V94.3211H284.408V87.4862Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M295.347 0H302.184V6.83486H295.347V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M295.347 10.9358H302.184V17.7706H295.347V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M295.347 21.8716H302.184V28.7064H295.347V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M295.347 32.8073H302.184V39.6422H295.347V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M295.347 43.7431H302.184V50.578H295.347V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M295.347 54.6789H302.184V61.5138H295.347V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M295.347 98.422H302.184V105.257H295.347V98.422Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M306.286 0H313.122V6.83486H306.286V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M306.286 10.9358H313.122V17.7706H306.286V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M306.286 21.8716H313.122V28.7064H306.286V21.8716Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M306.286 32.8073H313.122V39.6422H306.286V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M306.286 43.7431H313.122V50.578H306.286V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M306.286 87.4862H313.122V94.3211H306.286V87.4862Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M306.286 120.294H313.122V127.128H306.286V120.294Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M317.224 10.9358H324.061V17.7706H317.224V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M317.224 32.8073H324.061V39.6422H317.224V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M317.224 43.7431H324.061V50.578H317.224V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M317.224 54.6789H324.061V61.5138H317.224V54.6789Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M317.224 65.6147H324.061V72.4495H317.224V65.6147Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M317.224 98.422H324.061V105.257H317.224V98.422Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M317.224 109.358H324.061V116.193H317.224V109.358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M317.224 120.294H324.061V127.128H317.224V120.294Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M317.224 131.229H324.061V138.064H317.224V131.229Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M317.224 142.165H324.061V149H317.224V142.165Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M328.163 0H335V6.83486H328.163V0Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M328.163 10.9358H335V17.7706H328.163V10.9358Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M328.163 32.8073H335V39.6422H328.163V32.8073Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M328.163 43.7431H335V50.578H328.163V43.7431Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M328.163 65.6147H335V72.4495H328.163V65.6147Z" fill="currentColor" fill-opacity="0.15" />
        <path d="M328.163 76.5505H335V83.3853H328.163V76.5505Z" fill="currentColor" fill-opacity="0.15" />
      </svg>

      <img class="userCode" :src="data" />
      <div class="tip" v-html="text"></div>
    </div>
  </div>
</template>
<script>
import util from "./../utils/common";
export default {
  props: ["data", "bColor", "title", "textColor", "tip", "type", "theme"],
  data() {
    return {
      text: "",
    };
  },
  watch: {
    tip: {
      handler(val) {
        this.text = (val||'').replace(/\n/g, "<br/>");
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  computed: {
    model() {
      const { bColor } = this;
      const sty = {
        assistance: { borderColor: bColor },
        lightup: { backgroundColor: `${util.rgbToRgba(this.bColor, 0.3)}` },
      };
      if (this.theme == "theme2") {
        return {
          backgroundColor: this.$util.rgbToRgba(this.bColor, 0.5) ,
        };
      }
      return sty[this.type];
    },
  },
  methods: {},
};
</script>
<style lang="stylus" scoped>
div {
  box-sizing: border-box;
}

.model {
  width: 351px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 5px solid;
  box-sizing: border-box;
  &.lightup{
    padding:10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  &.theme2 {
    padding: 10px;
    border: none;
    margin: 25px auto 0;
    box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
    background:  rgba(255, 255, 255, 0.1);
    .modelTitle {
      margin-top: -10px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 12px 12px;
    }
  }
  .modelTitle {
    position: absolute;
    margin-top: -20px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    border-radius: 6px;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    z-index:1;
    &.lightup{
      margin-top: -10px;
      border-radius: 0px 0px 12px 12px;
    }
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;
    padding: 44px 15px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;


    svg {
      position: absolute;
      top: 5px;
      left: 2px;
      right: 2px;
    }

    .userCode{
      position: relative;
      width:152px;
    }
    .tip{
      margin-top:24px;
      text-align: center;
      width: 280px;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #595959;
    }
  }
}
</style>
